module.exports = {
      id: "refresh-icon-usage",
      viewBox: "0 0 18 18",
      url: "/" + "sprite-a402f8ffc4310bc2e096ed6c94b22ccb.svg#refresh-icon",
      toString: function () {
        return this.url;
      }
    }